
import { mapState, mapGetters } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
const STATUSES = ["Completed", "Cancelled", "Preparing"];
export default {
  components: { noDataLabel },
  data() {
    return {
      series: [],
      chartOptions: {
        labels: STATUSES,
        colors: ["#28D484", "#FF654E", "#FFC830"],
        chart: {
          type: "donut",
          width: "500px",
          height: "400px"
        },
        plotOptions: {
          pie: {
            donut: {
              size: 50,
              width: "1000px",

              labels: {
                show: true
              }
            }
          }
        },
        legend: {
          position: "bottom"
        }
      }
    };
  },
  props: {
    showDetailPageLink: {
      default: true
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters("report", ["getChannels"]),
    ...mapState("report", ["aggregates"])
  },
  watch: {
    aggregates() {
      this.init();
    }
  },
  methods: {
    init() {
      this.series = [];
      STATUSES.forEach(
        ((status) => {
          if (status == "Preparing") {
            this.series.push(
              Number(this.aggregates?.new_orders || 0) +
                Number(this.aggregates?.on_going || 0) +
                Number(this.aggregates?.ready_for_payment || 0) +
                Number(this.aggregates?.ready_for_dispatch || 0)
            );
            // this.aggregates.reduce(
            //       (tot, item) => {
            //        return tot + Number()
            //       },
            //       0
            //     )
          } else {
            this.series.push(
              this.aggregates?.[status.toLocaleLowerCase()] || 0
            );
          }
        }).bind(this)
      );
    }
  }
};
